import { render, staticRenderFns } from "./Acuicultura.vue?vue&type=template&id=62e7e8a2"
import script from "./Acuicultura.vue?vue&type=script&lang=js"
export * from "./Acuicultura.vue?vue&type=script&lang=js"
import style0 from "./Acuicultura.vue?vue&type=style&index=0&id=62e7e8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports